(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theirs-enquiry"] && !Shopify.designMode) return;
  try {
    
function populateTheirsProductLink(root = document) {
  const field = root.querySelector('[data-product-url]');
  const value = new URLSearchParams(window.location.search).get('product_url');
  if (!field || field.value || !value || value.length > 2000) return;
  try { const url = new URL(value); if (url.protocol === 'https:' || url.protocol === 'http:') field.value = url.href; } catch {}
}
function populateTheirsRequestReference(root = document) {
  const field = root.querySelector('[data-request-reference]');
  const display = root.querySelector('[data-request-reference-display]');
  if (!field) return;
  let reference = sessionStorage.getItem('theirs-request-reference');
  if (!reference) {
    const now = new Date();
    const date = now.toISOString().slice(2, 10).replaceAll('-', '');
    const suffix = Math.random().toString(36).slice(2, 6).toUpperCase();
    reference = `TH-RQ-${date}-${suffix}`;
    sessionStorage.setItem('theirs-request-reference', reference);
  }
  field.value = reference;
  if (display) display.textContent = reference;
}
function prepareTheirsRequest(root = document) {
  populateTheirsProductLink(root);
  populateTheirsRequestReference(root);
}
prepareTheirsRequest();
document.addEventListener('shopify:section:load', event => prepareTheirsRequest(event.target));

  } catch(e) { console.error(e); }
})();
})();
